import { useGraphQLQuery } from '@betterment/graphql';
import { Card, Heading, Separator } from '@betterment/samba-react';
import { CardLoader } from '@betterment/shared-components/src/components/card-loader/card-loader';

import { AccountReturnsDocument } from './graphql/accountReturns.generated';

type Props = { accountId: string };

export const AccountReturnsCard: React.FC<Props> = ({ accountId }) => {
  const { data } = useGraphQLQuery(AccountReturnsDocument, { variables: { id: accountId }, throwOnError: true });
  const account = data?.account;

  if (!account) return <CardLoader />;

  if (account.__typename !== 'ManagedAccount') {
    return null;
  }

  const { legacyGoalId } = account;

  return (
    <Card>
      <Card.Header css={{ padding: 'space.300' }}>
        <Heading as="h3" variant="title200">
          Returns
        </Heading>
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content css={{ padding: 'space.300' }}>
        Placeholder: rails returns data for account with legacy goal ID: {legacyGoalId}
      </Card.Content>
    </Card>
  );
};
